export const PUBLIC_PATH = 'api/public/v1'
export const ADMIN_PATH = 'api/admin/v1'

export const IMAGES_WITH_PRODUCTS = 'collection-images-with-product-items'
export const COLLECTIONS = 'collections'
export const COLLECTION_IMAGES = 'collection-images'
export const ITEM_IMAGE_ASSOCIATIONS = 'item-image-associations'
export const BRANDS = 'brands'
export const PRODUCT_MODELS = 'product-models'
export const PRODUCT_LISTINGS = 'product-listings'
export const PRODUCT_ITEMS = 'product-items'
export const SHOWINGS = 'showings'
export const STORAGE_SPACES = 'storage-spaces'
export const FEATURES = 'features'
export const POLYMORPHIC_REFERENCES = 'polymorphic-references'
export const POLY_INTEGER_REFERENCES = 'poly-integer-references'
export const POLYMORPHIC_ASSOCIATIONS = 'polymorphic-associations'

export const amsApiResourcePath = (api_path, ams_type) =>
{
  return  api_path + '/' + ams_type.replace(/-/g, '_')
}

export const apiRoute = (api_resource_path, record_id) =>
{
  return api_resource_path + '/' + record_id
}
